import * as React from "react"
import { Button } from "./button"
import { IButtonProps } from "./buttons.interface"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../recoil/atoms/room"

const _PrimaryButton: React.FC<IButtonProps> = (props): JSX.Element => {
  const roomStyles = useRecoilValue(brandingSelector)
  return (
    <Button
      {...props}
      bg={roomStyles?.accessButtonBackgroundColor ?? "#1AC541"}
      border={
        roomStyles?.accessButtonBorderColor
          ? `1px solid ${
              roomStyles?.accessButtonBorderColor
                ? roomStyles.accessButtonBorderColor
                : "transparent"
            }`
          : "0px"
      }
      textColor={roomStyles?.accessButtonTextColor ?? "#FFFFFF"}
      _hover={{
        backgroundColor: roomStyles?.accessButtonMouseoverColor ?? "#24A840",
        textColor: roomStyles?.accessButtonTextMouseoverColor ?? "#FFFFFF"
      }}
      _disabled={{ opacity: 0.25 }}
      pointerEvents={props.isDisabled ? "none" : "unset"}
    />
  )
}

export const PrimaryButton = React.memo(_PrimaryButton)
